import { LoginProjectData } from '../../../api/dasboard/types';
import { Action, ActionType, StatisticCardState } from './types';

export const initialState: StatisticCardState = {
  currProject: null,
  fetching: true,
  error: false
};

export const init = (initProject: LoginProjectData | undefined): StatisticCardState => {
  if (initProject) {
    return {
      ...initialState,
      currProject: initProject
    };
  }
  return initialState;
};

export const statisticCardReducer = (
  state: StatisticCardState,
  action: Action
): StatisticCardState => {
  switch (action.type) {
    case ActionType.stopFetching:
      return { ...state, fetching: false };
    case ActionType.getDataStart:
      return { ...state, fetching: true };
    case ActionType.getDataSuccess:
      return {
        ...state,
        fetching: false,
        currProject: action.payload as LoginProjectData
      };
    case ActionType.getDataFail:
      return { ...state, fetching: false, error: true };
    default:
      throw new Error('Unknown action type in Statistic Card reducer!');
  }
};
